import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    instagramfeed_redicrect_uri: 'https://edit.istay.io/auth_instagram.html'
  },
  mutations: {
  },
  actions: {
    async getThirdparty () {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'thirdparty/thirdparty.json'
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setThirdparty ({ state }, data) {
      try {
        return await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'thirdparty/thirdparty.json',
          data: JSON.stringify(data)
        })
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async createAccessToken ({ state }, data) {
      const redirectUri = state.instagramfeed_redicrect_uri
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-sns-feed',
          func: 'create-access-token',
          id: store.state.authentication.requestId,
          sns: data.sns,
          data: {
            client_id: data.appId,
            client_secret: data.appSecret,
            code: data.code,
            redirect_uri: redirectUri
          }
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return ex.response.data
      }
    },
    async getAccessToken ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-sns-feed',
          func: 'get-access-token',
          id: store.state.authentication.requestId,
          sns: data.sns
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async getInstagramFeed ({ state }, data) {
      try {
        const res = await axios.get(`https://graph.instagram.com/me/media?fields=id,media_type,media_url,thumbnail_url,caption,timestamp&access_token=${data.accessToken}`)
        return res.data
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    }
  },
  getters: {
    getInstagramRedirctUri: state => state.instagramfeed_redicrect_uri
  }
}
